const Urls = {
  GOOD_NEIGHBOR_POLICY: 'https://www.zillow.com/z/info/good-neighbor-policy/',
  RENTAL_USER_TERMS: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
  PERSONAL_CONTACT_WARNING_SCAM_PREVENTION:
    'https://www.zillow.com/rentals-network/how-landlords-can-avoid-5-common-rental-scams/',
};

export default Urls;
